import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import Swal from 'sweetalert2';
import { localurl } from '../utils';


export default function AgentsTable({ columns, data, onEdit, onDelete }) {

  const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const [hours, minutes] = timeStr.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const handleDeleteClick = (agent) => {
    if (agent.is_superuser) {
      Swal.fire(
        'Cannot Delete!',
        'Superuser agents cannot be deleted.',
        'error'
      );
      return;
    }

    console.log("Deleting agent:", agent);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${localurl}/agents/${agent.id}/`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (response.ok) {
            Swal.fire(
              'Deleted!',
              'Agent has been deleted.',
              'success'
            );
            onDelete(agent); // Assuming onDelete is a prop or function to update the UI
             window.location.reload();
          } else {
            const errorData = await response.json();
            Swal.fire('Error', errorData.message || 'Failed to delete agent.', 'error');
          }
        } catch (error) {
          Swal.fire('Error', error.message || 'Something went wrong.', 'error');
        }
      }
    });
  };

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell>
                <p className='font-medium text-[#71717A]'>{col.Header}</p>
              </TableCell>
            ))}
            <TableCell>
              <p className='font-semibold text-[#71717A]'>Actions</p>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((agent, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {columns.map((col, colIndex) => {
                const value = col.accessor.split('.').reduce((acc, part) => acc && acc[part], agent);

                if (col.accessor === "availability") {
                  return (
                    <TableCell key={colIndex}>
                      {agent.availability?.start_time ? `${formatTime(agent.availability.start_time)} - ${formatTime(agent.availability.end_time)}` : '-'}
                    </TableCell>
                  );
                }

                if (col.accessor === "availability.working_days") {
                  return (
                    <TableCell key={colIndex}>
                      {Array.isArray(value) && value.length > 0
                        ? `${value[0]} - ${value[value.length - 1]}`
                        : '24/7'}
                    </TableCell>
                  );
                }

                if (col.accessor === "is_active") {
                  return (
                    <TableCell key={colIndex}>
                      {value ? "Active" : "Offline"}
                    </TableCell>
                  );
                }

                return (
                  <TableCell key={colIndex}>
                    {String(value)}
                  </TableCell>
                );
              })}

              <TableCell>
                <div className='flex flex-row  gap-3'>
                  <button onClick={() => onEdit(agent)} className='bg-[#c5003e38] text-[#c5003e] p-2 text-base rounded-md'>
                    <FaRegEdit />
                  </button>
                  <button onClick={() => handleDeleteClick(agent)} className='bg-[#973f3f38] text-[#EF4444] p-2 text-base rounded-md'>
                    <RiDeleteBin6Line />
                  </button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>

      </Table>
    </TableContainer>
  );
}
